
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Breadcrumb from "../../../components/layout/Breadcrumb";
import { createDepartment } from "../../../redux/slice/getDepartmentsSlice";

export default function DepartmentCreate() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      name: name.trim(),
      code: code.trim(),
    };

    if (!payload.name || !payload.code) {
      toast.error("Department name and code are required.");
      return;
    }

    try {
      setSaving(true);

      await dispatch(createDepartment(payload)).unwrap();

      toast.success("Department created successfully!");

      navigate("/admin/departments");
    } catch (error) {
      toast.error(
        typeof error === "string"
          ? error
          : "Failed to create department."
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <div className="section-body policy-update">
        <div className="container-fluid">
          <h5 className="mb-3 mt-1">Create Department</h5>

          <div className="d-flex justify-content-between mt-3 mb-4">
            <Breadcrumb />

            <Button
              type="submit"
              form="departmentCreateForm"
              className="primary-btn"
              disabled={saving}
            >
              {saving ? "Saving..." : "Save Department"}
            </Button>
          </div>

          <div className="card mb-5">
            <div className="card-header">
              <Form id="departmentCreateForm" onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    <strong>Department Name</strong>
                  </Form.Label>

                  <Form.Control
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Enter department name"
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>
                    <strong>Department Code</strong>
                  </Form.Label>

                  <Form.Control
                    type="text"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    placeholder="Enter department code"
                    required
                  />
                </Form.Group>
              </Form>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
    </>
  );
}
